import api from "./axiosInstance";

export const getBookings = async (limit, offset) => {
  const response = await api.get(
    `api/v1/bookings/?limit=${limit}&offset=${offset}`,
  );
  return response.data;
};

export const getBookingById = async (id) => {
  const response = await api.get(`api/v1/bookings/${id}/`);
  return response.data;
};

export const createBookings = async (payload) => {
  const response = await api.post("api/v1/bookings/", payload);
  return response.data;
};

export const deleteBookings = async (id) => {
  await api.delete(`api/v1/bookings/${id}/`);
};

export const getBookingsByArtist = async (artistId) => {
  const res = await api.get(`api/v1/bookings/`, {
    params: {
      artist: artistId,
    },
  });
  return res.data;
};

export const updateBookings = async (id, payload) => {
  const response = await api.patch(`api/v1/bookings/${id}/`, payload);
  return response.data;
};

export const createBookingInvoices = async (payload) => {
  const res = await api.post(`api/v1/payment-instalments/`, payload);
  return res.data;
};


export const generateBookingProforma = async (id) => {
  const res = await api.post(`api/v1/payment-instalments/${id}/generate-proforma/`);
  return res.data;
};

export const generateBookingInvoice = async (id) => {
  const res = await api.post(`api/v1/payment-instalments/${id}/create-invoice/`);
  return res.data;
};

export const cancelBookingInvoice = async (id) => {
  const res = await api.post(`api/v1/payment-instalments/${id}/cancel/`);
  return res.data;
};